<template>
<v-container fluid grid-list-sm pa-0 ma-0>
<v-dialog v-model="dialog" persistent scrollable max-width="500px">
   
<v-card max-width="500px">

 <v-app-bar flat dense dark color="primary">  
     <v-toolbar-items>
      <v-btn icon   color="success" @click.stop="sav()">
          <v-icon >print</v-icon>
      </v-btn>
      <v-btn icon color="warning"><v-icon >description</v-icon>
      </v-btn>
      <v-btn  text dark color="lime accent-2"><v-icon left>save</v-icon>Tax Invoice
      </v-btn>

 <!--<v-btn fab top medium class="hidden-sm-and-up" dark><v-icon>add</v-icon></v-btn><v-spacer/>
 <v-btn fab top large class="hidden-xs-only" dark><v-icon>add</v-icon></v-btn><v-spacer/>-->
 
     </v-toolbar-items><v-spacer/>
     <v-btn icon color="error" @click.stop="dialog = false" pa-1 ma-1 small><v-icon>close</v-icon></v-btn> 
 </v-app-bar>
  
   <v-card-text>
    <v-container ma-0 pa-1>
    
    <v-layout wrap row>
        <v-flex>
        <h1>print And Payment</h1>
        </v-flex>
    </v-layout>
    <v-layout row wrap>
      
        <v-flex>
        <v-form>
            <v-flex v-for="(i, index) in this.card" :key="index"  layout>
            <v-autocomplete
              v-model="selectbank"
              :items="banknames"
              item-text="name"
              label= "select Bank"
              single-line
              
              ref="0"
              v-on:keydown.enter="gonext('1')"
            >
            <template slot="no-data">
                <v-btn @click.stop="partyDialog=true" color=success>add new Party</v-btn>
            </template>
            </v-autocomplete>

                <v-text-field label="Card Amount Rs." id=index v-model="i.cardAmt"></v-text-field>
                <v-card-actions>
                <v-icon ma-10 pa-10 medium color="error"  @click.stop="deleteCard(index)">delete_forever</v-icon>
                </v-card-actions>
            </v-flex>
            <v-flex>
                <v-text-field label="Cash Rs" v-model="cash"></v-text-field>
            </v-flex>
            <v-flex>
               <!--  <v-chip>{{balance}} {{ selectbank }}</v-chip> -->
                 <v-btn @click.stop="remember">model save </v-btn>
            </v-flex>
        </v-form>
        </v-flex>
    </v-layout>
    

  
    </v-container>
    </v-card-text>
    <v-card-actions>
        <v-spacer/>
        <v-btn @click.stop="addcard()" fab bottom right color="success" medium  dark><v-icon>add</v-icon></v-btn>
    </v-card-actions>
   
</v-card>
 
</v-dialog>
</v-container>
</template>

<script>
export default {
    data () {
        return {
            cash:null,
            card:[{
                 bank: null,
                 cardAmt: null,
                 cardNo: null
                 }],
            newcd: 1,
            bank: { "_id": "5c4bfc622bdf6253606be861", "name": "Indian Bank", "group": "Mumbai west", "primary": false, "__v": 0 }
        }
    },
    computed: {
        dialog: {
            get() {
                return this.$store.state.printDialog
            },
            set() {
                this.$store.dispatch('printDialog')
            }
        },
        balance() {
            return this.$store.state.invoice.totalCT
        },
        banknames (){
             return this.$store.state.ledgerFilter.banknames
        },
        selectbank: {
            get () {
            if (this.$store.state.ledgerFilter.rem != null){
                return this.$store.state.ledgerFilter.rem
            } else {
                return this.banknames != null ? this.banknames[0]: null
            }
            },
            set (value) {
                this.$store.dispatch('ledgerFilter/saveRemember', { name: value, group: 'Bank'})
            }
        }
    },
    methods: {
        dialogSet() {
            this.$store.dispatch('printDialog')
        },
        sav() {
            this.$store.dispatch('invoice/sav')
        },
        addcard() {
            this.card.push({ bank: 'Indian bank', cardAmt: null , cardNo: null})
        },
        deleteCard(index) {
            alert('hi')
            this.card.splice(index,1)
            this.newcd = this.card.length
        },
        remember() {
            this.$store.dispatch('ledgerFilter/saveRemember', { name: 'hello'})
        }
    },
    mounted() {
        this.$store.dispatch('ledgerFilter/fetchBank', {name: 'Bank A/c'})
        this.$store.dispatch('ledgerFilter/fetchRemember')
    }
}
</script>

<style>

</style>
